<template>
  <div class="flex flex-col gap-8">
    <actual-times-table />
    <sold-time-table />
  </div>
</template>

<script>
import ActualTimesTable from "@/Job/ActualTimesTable.vue";
import SoldTimeTable from "@/Job/SoldTimeTable.vue";

export default {
  components: {
    ActualTimesTable,
    SoldTimeTable
  },
  created() {
    // Fire-and-forget: rendering must not wait on it.
    import("@/components/datatable_tailwind.css");
  }
};
</script>

<style lang="scss" scoped></style>
